import { useEffect, useRef } from 'react';

export function useGameLoop(callback: (delta: number) => void, active: boolean): void {
  const callbackRef = useRef(callback);
  callbackRef.current = callback;

  const frameRef = useRef(0);
  const lastTimeRef = useRef(0);

  useEffect(() => {
    if (!active) {
      cancelAnimationFrame(frameRef.current);
      lastTimeRef.current = 0;
      return;
    }

    function tick(time: number) {
      const delta = lastTimeRef.current ? time - lastTimeRef.current : 0;
      lastTimeRef.current = time;
      callbackRef.current(delta);
      frameRef.current = requestAnimationFrame(tick);
    }

    frameRef.current = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(frameRef.current);
  }, [active]);
}
